<div class="task-page-container container">
	<div class="logos"><img src="assets/images/Atos.svg" /></div>

	<div class="task">
		<div class="title" *ngIf="!this.taskFinished && !this.taskPredecessor">
			<p>{{ labels.lbl_thank_approving }}</p>
			<p>{{ labels.lbl_questions_contact }}</p>
		</div>

		<div *ngIf="this.taskFinished && !this.taskPredecessor">
			<div class="title" *ngFor="let task of taskData">
				<p class="left-align">{{ labels.lbl_tarefa_ja_executada }}</p>
				<p class="left-align">{{ labels.lbl_chamado_tarefa }} {{ task.task }}</p>
				<p class="left-align">
					<b>{{ labels.lbl_edocs_aprovador }}:</b> {{ task.nameApproval }}<br />
					<b>{{ labels.lbl_cmdb_email }}:</b> {{ task.emailApproval }}<br />
					<b>{{ labels.lbl_chamado_status_tarefa }}:</b> {{ task.statusTask }}
				</p>
				<p class="left-align">{{ labels.lbl_questions_contact }}</p>
			</div>
		</div>

		<div *ngIf="this.taskSleeping && this.taskPredecessor">
			<div class="title" *ngFor="let task of taskData">
				<p>{{ labels.lbl_chamado_tarefa }} {{ task.task }}</p>
				<p>{{ labels.lbl_para_executar_tarefa }}</p>
			</div>
		</div>

		<div *ngIf="!this.taskSleeping">
			<div class="radio-container" *ngIf="this.taskPredecessor">
				<div class="title" *ngFor="let item of taskData">
					<p>{{ labels.lbl_chamado_tarefa }} {{ item.task }}</p>
					<p>{{ labels.lbl_escolha_tarefa_concluida_antes }}</p>
				</div>
				<div class="radio-group">
					<div *ngFor="let item of taskPredecessors" class="radio-item">
						<input
							type="radio"
							name="option"
							[id]="'option-' + item.task"
							[value]="item.task_id"
							[(ngModel)]="selectedTaskId"
							(change)="onRadioChange($event)" />
						<label [for]="'option-' + item.task">{{ item.task }}</label>
					</div>
				</div>
				<button class="button" (click)="onSave()">{{ labels.lbl_geral_salvar }}</button>
			</div>
		</div>

		<div *ngIf="!this.taskPredecessor" class="message">MySupport</div>
	</div>

	<footer *ngIf="this.taskPredecessor" class="message">MySupport</footer>
</div>

<img class="blue-satisfaction-ball" src="assets/images/BolinhaAzul.svg" />
<img class="orange-satisfaction-ball" src="assets/images/BolinhaRosa.svg" />
